export { ROUTE_ALIASES } from './constants';
export {
  isStaticAlias,
  isDynamicAlias,
  isMatchPageAlias,
  getCurrentPath,
  getMatchPageUrl,
  getUrlByDynamicAlias,
} from './utils';
export { useResultLocation } from './hooks/use-result-location';
export { PrivateRoute } from './components/PrivateRoute';
export { MatchRedirect } from './components/MatchRedirect';
export { RouteWithSubRoutes } from './components/RouteWithSubRoutes';
export { RedirectToAliasesOrNotFound } from './components/RedirectToAliasesOrNotFound';

